import { useState } from "react";

const categories = [
  { id: "daily", label: "Daily" },
  { id: "weekly", label: "Weekly" },
  { id: "monthly", label: "Monthly" },
];

export default function TaskInput({ onCreateTask }) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("daily");

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onCreateTask(trimmed, category);
    setName("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div>
      <div className="task-input-wrapper">
        <input
          data-testid="task-input"
          type="text"
          className="task-input-field"
          placeholder="What needs to be done?"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
        />
      </div>
      <div className="category-selector" data-testid="task-category-select">
        {categories.map((cat) => (
          <button
            key={cat.id}
            data-testid={`category-btn-${cat.id}`}
            className={`category-btn ${category === cat.id ? `active-${cat.id}` : ""}`}
            onClick={() => setCategory(cat.id)}
            type="button"
          >
            {cat.label}
          </button>
        ))}
      </div>
    </div>
  );
}
